import ToastCustomize from "../kits/ToastCustomize";

import { ResponseType } from "./SiCaTypes";

function apiResponseHandler(
  res: ResponseType,
  text: { success?: string; failure?: string }
) {
  if (+res.status === 1) {
    if (text.success) {
      ToastCustomize({
        mainText: text.success,
        duration: 2000,
        toastType: "success",
        color: "success",
      });
    }
  } else if (text.failure) {
    ToastCustomize({
      mainText: text.failure,
      duration: 2000,
      toastType: "failed",
      color: "danger",
    });
  }
}

function nodeTypeConvertToNumber(type: string) {
  switch (type) {
    case "start":
      return 1;
    case "end":
      return 2;
    case "phone_call":
      return 3;
    case "email":
      return 4;
    case "sms":
      return 5;
    case "letter":
      return 6;
    default:
      return 0;
  }
}

function nodeTypeConvertToString(type: number) {
  switch (type) {
    case 1:
      return "start";
    case 2:
      return "end";
    case 3:
      return "phone_call";
    case 4:
      return "email";
    case 5:
      return "sms";
    case 6:
      return "letter";
    default:
      return "custom";
  }
}

function nodeTypeConvertToTitle(type: number) {
  switch (type) {
    case 1:
      return "شروع";
    case 2:
      return "پایان";
    case 3:
      return "تماس تلفنی";
    case 4:
      return "ایمیل";
    case 5:
      return "پیامک";
    case 6:
      return "نامه";
    default:
      return "گره جدید";
  }
}

export {
  apiResponseHandler,
  nodeTypeConvertToNumber,
  nodeTypeConvertToString,
  nodeTypeConvertToTitle,
};
